// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/hbc.scss
// module id = 718
// module chunks = 0